import { render, staticRenderFns } from "./qs3-10.vue?vue&type=template&id=ad88fdf4&scoped=true&"
import script from "./qs3-10.vue?vue&type=script&lang=js&"
export * from "./qs3-10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad88fdf4",
  null
  
)

export default component.exports